<template>
  <div class="done">
    <div class="content">
      <sass-icon type="hi-yiwancheng" style="font-size: 50px;" />
      <div class="desc">
        <h3>修改完成</h3>
        <p>
          {{ time }}秒后自动跳转登录页，
          <a-button type="link" size="small" @click="handleJump">立即跳转</a-button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import CommonIcon from '@/components/common-icon'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'Done',
  components: {
    CommonIcon
  },
  beforeRouteEnter(to, from, next) {
    const fromName = from.name
    if (fromName === 'FSetPassword' || fromName === 'RSetPassword' || fromName === 'CSetPassword') {
      next()
    } else {
      next({ name: to.matched[to.matched.length - 2].name })
    }
  },
  data() {
    return {
      time: 3,
      timer: null
    }
  },
  mounted() {
    const timer = setInterval(() => {
      this.time = this.time > 0 ? (this.time - 1) : 0
      if (this.time === 0) {
        this.handleJump()
        clearInterval(timer)
        // this.timer = null
      }
    }, 1000)
  },
  methods: {
    ...mapActions(['Logout']),
    handleJump() {
      if (this.$cookie.get(ACCESS_TOKEN)) {
        this.Logout()
      } else {
        this.$router.replace({ name: 'CommonLogin' })
        // window.location.reload()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.done {
  display: table;
  margin: 68px auto;
}
.content {
  display: flex;
}
.desc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 16px;
}
</style>
